import {pageInfo, exportData, downloadFile} from './../api';
import { Message } from 'element-ui';
const monthBill = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    exportDataObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    EXPORT_DATA(state, data) {
      state.exportDataObj = data;
    },
    DOWNLOAD_FILE(state, data) {
      state.downloadFileObj = data;
    }
  },
  actions: {
    //查询
    async pageInfo({ commit }, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //导出文件
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    //下载文件
    async downloadFile({ commit }, obj) {
      let resp = await downloadFile(obj);
      commit('DOWNLOAD_FILE', resp);
    }
  }
}
export default monthBill



// WEBPACK FOOTER //
// ./src/page/bill/monthBill/store/monthBill.store.js